document.addEventListener('DOMContentLoaded', function() {
  if (window.location.pathname === '/pages/the-icon') {
      const params = new URLSearchParams(window.location.search);

      if (params.get('utm_source') === 'theicon' && params.get('utm_medium') === 'podcast') {
          const campaignParam = params.get('utm_campaign');

          // Podcast names are proper nouns and stay as-is; only the surrounding sentence is translated.
          const podcastNames = {
              "ThatUFOPodcast": "That UFO Podcast",
              "SurvivingTheSurvivor": "Surviving the Survivor",
              "MavsOutsiders": "Mavs Outsiders",
              "YouDontEvenLikeSports": "You Don't Even Like Sports",
              "OaklandWarriorsAGoldenStatWarriorsPodcast": "Oakland Warriors: A Golden State Warriors Podcast",
              "RanksFC": "Ranks FC",
              "TheRangeLife:AShowSometimesAboutGolf": "That Range Life: A Show Sometimes About Golf",
              "TheICeAndCoachSportsShow": "The Iceman & Coach Sports Show Fire Footwear: A Sneaker Podcast",
              "BaseballTogetherPodcast": "Baseball Together Podcast",
              "PintGlassFootballPodcast": "Pint Glass Football Podcast: NFL and College Football",
              "AheadOfTheCurve": "Ahead Of The Curve with Jonathan Gelnar",
              "TheNBAPodcast": "The NBA Podcast",
              "WinsidrWNBAShow": "Winsidr WNBA Show",
              "politicalfootball": "Political Football with Clev, Dave & Scott",
              "idpshow": "The IDP Show"
          };

          const messageTemplate = window.themeStrings?.podcastWelcomeHtml
              ?? 'Welcome {{ podcast }} listeners! Enjoy 15% off your next order when you use code: <strong>{{ code }}</strong>';

          const codes = {
              "ThatUFOPodcast": "thatufo",
              "SurvivingTheSurvivor": "STS",
              "MavsOutsiders": "mavsoutsiders",
              "YouDontEvenLikeSports": "youdontsports",
              "OaklandWarriorsAGoldenStatWarriorsPodcast": "warriorspod",
              "RanksFC": "ranks",
              "TheRangeLife:AShowSometimesAboutGolf": "thatrangelife",
              "TheICeAndCoachSportsShow": "iceman",
              "BaseballTogetherPodcast": "baseballtogether",
              "PintGlassFootballPodcast": "pgfp",
              "AheadOfTheCurve": "aotc",
              "TheNBAPodcast": "thenbapod",
              "WinsidrWNBAShow": "winsidr23",
              "idpshow": "idpshow"
          };

          const podcastName = podcastNames[campaignParam];

          if (podcastName) {
              const targetElement = document.querySelector('.hero__paragraph p');

              if (targetElement) {
                  targetElement.innerHTML = messageTemplate
                      .replace('{{ podcast }}', podcastName)
                      .replace('{{ code }}', codes[campaignParam]);
              }
          }
      }
  }
});